import React, { Component } from 'react'
import mapboxgl from 'mapbox-gl'
import './Map.css'
import Data from '../../data/layers.js'
import Organization from '../Organization/Organization'
import _ from 'underscore'
import $ from "jquery"
var popup = new mapboxgl.Popup({
   closeButton: true,
   closeOnClick: false
})

class Map extends Component {
  componentDidMount() {
    var _self = this
    $('#arts-secondary').show();
    mapboxgl.accessToken = 'pk.eyJ1IjoiY2FzdG1hcCIsImEiOiJjajNkZGg0bHgwMDBhMzFyc2w5djV1ajBjIn0.3eCl2b5ASQ9KiaxDxNNYJA';
      this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/castmap/cjjes8qlw96w12sm8d2z0h3cg',
      center: [-122.41, 37.77],
      zoom: 14,
      pitch: 20
    });
    this.map.addControl(new mapboxgl.NavigationControl())
    this.map.on('load', () => {
      _self.map.addLayer(Data['buildings'])
      _self.map.addLayer(Data['buildingsHover'])
      _self.map.addLayer(Data['parcels'])
      _self.category = 'all'
      _self._getOrganizations()
    })

    $('#map').on('mousedown', function(e) {
      if (e.target.localName === 'canvas') {
        $('.tertiary-menu').hide()
      }
    })

    _self.map.on('mouseenter', 'buildings', function(e) {
      _self.map.getCanvas().style.cursor = 'pointer';
      // console.log('enter')
    })

    _self.map.on('mouseleave', 'buildings', function(e) {
      //_self.map.setFilter('buildingsHover', ["has", "nofield"])
      _self.map.getCanvas().style.cursor = '';
      //console.log('leave')
    })

    _self.map.on('mouseenter', 'totals', function(e) {
      _self.map.getCanvas().style.cursor = 'pointer';
      // console.log('enter')
    })

    _self.map.on('mouseleave', 'totals', function(e) {
      //_self.map.setFilter('buildingsHover', ["has", "nofield"])
      _self.map.getCanvas().style.cursor = '';
      //console.log('leave')
    })

    _self.map.on('mouseenter', 'devPipelineMixeduse', function(e) {
      _self.map.getCanvas().style.cursor = 'pointer';
      // console.log('enter')
    })

    _self.map.on('mouseleave', 'devPipelineMixeduse', function(e) {
      //_self.map.setFilter('buildingsHover', ["has", "nofield"])
      _self.map.getCanvas().style.cursor = '';
      //console.log('leave')
    })

    _self.map.on('mouseenter', 'devPipelineResidential', function(e) {
      _self.map.getCanvas().style.cursor = 'pointer';
      // console.log('enter')
    })

    _self.map.on('mouseleave', 'devPipelineResidential', function(e) {
      //_self.map.setFilter('buildingsHover', ["has", "nofield"])
      _self.map.getCanvas().style.cursor = '';
      //console.log('leave')
    })

    _self.map.on('click', 'parcels', function(e) {
     var buildingId = e.features[0].properties.id
     $('#parcel-id').html(buildingId)
   })

   _self.map.on('mouseover', 'buildings', function(e) {
     var buildingId = e.features[0].properties.id
     _self.map.setFilter('buildingsHover', ["==", "id", buildingId])
   })

  _self.map.on('click', 'totals', function(e) {
      var buildingId = e.features[0].properties.buildingId
      var title = e.features[0].properties.title
      _self.map.setFilter('buildingsHover', ["==", "id", buildingId])
      if (buildingId !== 'none') {
        var orgs = '<b>' + _self.groupedOrgs[buildingId].length + ' Organizations</b>'
        _.each(_self.groupedOrgs[buildingId], function(feature) {
          orgs = orgs + '<a style="display: block;" class="btn-org" href="#" data-props=\'' + JSON.stringify(feature) + '\'>' + feature['title'] + '</a>';
        })
        setTimeout(function() {
          $('.cast-popup').parents('.mapboxgl-popup-content').find('.mapboxgl-popup-close-button').trigger('click')
        }, 1)
       popup
       .setLngLat(e.lngLat)
       .setHTML('<div class="multiple-orgs-popup">' + orgs + '</div>')
       .addTo(_self.map)
      } else {
        var feature = JSON.parse(e.features[0].properties.properties)
        popup
        .setLngLat(e.lngLat)
        .setHTML('<a style="display: block;" class="btn-org" href="#" data-props=\'' + JSON.stringify(feature) + '\'><b>1 Organizations</b><br>' + title + '</a>')
        .addTo(_self.map)
      }
   $('.btn-org').on('click', function(e) {
     e.preventDefault()
     var props = $(this).data('props')
     _self._showOrganization(props)
   })
  })

  _self.map.on('click', 'buildings', function(e) {
     var buildingId = e.features[0].properties.id
     _self.map.setFilter('buildingsHover', ["==", "id", buildingId])
     if (_self.groupedOrgs[buildingId]) {
     var orgs = '<b>' + _self.groupedOrgs[buildingId].length + ' Organizations</b>'
     _.each(_self.groupedOrgs[buildingId], function(feature) {
       orgs = orgs + '<a style="display: block;" class="btn-org" href="#" data-props=\'' + JSON.stringify(feature) + '\'>' + feature['title'] + '</a>';
     })
     setTimeout(function() {
       $('.cast-popup').parents('.mapboxgl-popup-content').find('.mapboxgl-popup-close-button').trigger('click')
     }, 1)
    popup
    .setLngLat(e.lngLat)
    .setHTML('<div class="multiple-orgs-popup">' + orgs + '</div>')
    .addTo(_self.map);
  }
   $('.btn-org').on('click', function(e) {
     e.preventDefault()
     var props = $(this).data('props')
     _self._showOrganization(props)
   });
  })
 }

  componentWillReceiveProps(state) {
    var _self = this
    // organization filter
    if (state.filters.length !== 0) {
      //console.log(state.filters)
      if (_self.category !== state.filters) {
        _self._getOrganizations(state.filters)
        _self.category = state.filters
      }
    }
    // layers
    _.each(state.layers, function(layer) {
      if (layer.visible === true) {
        if (!(_self.map.getLayer(layer.id))) {
          if (Data[layer.id]) {
            _self.map.addLayer(Data[layer.id], 'waterway-label')
            // keep arts orgs on top
            //_self.map.moveLayer('buildings')
            _self.map.moveLayer('totals')
            _self.map.moveLayer('totalLabels')

            // Hover layers
            if (Data[layer.id].hover) {
              var hoverLayer = Data[layer.id].hover.layer
              _self.map.addLayer(Data[hoverLayer], 'waterway-label')
              _self.map.on('mouseenter', layer.id, function(e) {
                var id = e.features[0].properties[Data[layer.id].hover.field]
                _self.map.setFilter(hoverLayer, ['==', Data[layer.id].hover.field, id])
                //$('.layer-info').html(e.features[0].properties.corridor)
              })
              _self.map.on('mouseleave', layer.id, function(e) {
                //_self.map.setFilter(hoverLayer, ['has', 'nofield'])
                _self.map.setFilter(hoverLayer, ['has', 'nofield'])
              })
            }

            // Labels
            if (Data[layer.id].labels) {
              var labelsLayer = Data[layer.id].labels
              _self.map.addLayer(Data[labelsLayer], 'waterway-label')
            }

            // borders
            if (Data[layer.id].borders) {
              var bordersLayer = Data[layer.id].borders
              _self.map.addLayer(Data[bordersLayer], 'waterway-label')
            }

            // Popups
            if (Data[layer.id].popup) {
              _self.map.on('click', layer.id, function(e) {
              var str = Data[layer.id].popup.content
              var results = str.match(/{(.*?)}/g).map(function(val) {
                return val.replace('{', '').replace('}', '')
              })
              var fields = []
              _.each(results, function(result) {
                 fields.push({
                   target: '{' + result + '}',
                   value: e.features[0].properties[result]
                })
              })
              var content = str;
              _.each(fields, function(field) {
                if (typeof field.value === "undefined") field.value = "Unknown";
                if (typeof field.value === "") field.value = "Unknown";
                if (field.target === '{TOTAL_GSF}') {
                  content = content.replace(field.target, _self.numberWithCommas(field.value))
                } else {
                  content = content.replace(field.target, field.value)
                }
              })
              $('#organization').css('right', '-680px')
              $('.cast-popup--title').html(Data[layer.id].popup.title)
              $('.cast-popup--content').html(content)
              $('#cast-popup').show()
              })
            }
          }
        } else {
          _self.map.setLayoutProperty(layer.id, 'visibility', 'visible')
          if (Data[layer.id].hover) {
            _self.map.setLayoutProperty(Data[layer.id].hover.layer, 'visibility', 'visible')
          }
        }
      }
    })

    // slight delay to avoid flashing
    _.each(state.layers, function(layer) {
      if (layer.visible === false) {
        if (_self.map.getLayer(layer.id)) {
           _self.map.setLayoutProperty(layer.id, 'visibility', 'none')
        }
        if (Data[layer.id].hover) {
          _self.map.setLayoutProperty(Data[layer.id].hover.layer, 'visibility', 'none')
        }
      }
    })

    // filters
    _.each(state.filters, function(filter) {
      if (_self.map.getLayer(filter.id)) {
       if (filter.filter === 'All') {
         _self.map.setFilter(filter.id, ['has', 'category'])
       } else {
         _self.map.setFilter(filter.id, ['==', 'category', filter.filter])
       }
     }
    })
  }


  numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  _getOrganizations(category) {
    //console.log('querying orgs...');
    var _self = this
    var url = 'https://api.culturecompass.org/rest/categories?cat=' + category + '&_format=json'

    $('.loader').show();

    console.log(category)

    if (!(category)) {
      url = 'https://api.culturecompass.org/rest/organizations?_format=json'
    }
    if (category === 'cityOwned') {
      url = 'https://api.culturecompass.org/rest/organizations-city?_format=json'
    }
    if (category === 'nonProfit') {
      url = 'https://api.culturecompass.org/rest/organizations-nonprofit?_format=json'
    }

    if (_self.map.getLayer('totals')) {
    _self.map.removeLayer('totals')
    _self.map.removeLayer('totalLabels')
    _self.map.removeSource('totals')
    _self.map.removeSource('totalLabels')
    }

    var settings = {
      "async": true,
      "crossDomain": true,
      "url": url,
      "method": "GET"
    }
     $.ajax(settings).done(function(response) {
       if (response) {

          var buildings = ['any']
          _.each(response, function(row, index) {
            buildings.push(['==', 'id', row.field_building_id])
          })
          //console.log(buildings)
          var orgs = _.groupBy(response, 'field_building_id')
          //console.log(orgs)
          _self.groupedOrgs = orgs;
          _self.orgs = orgs;


          _self.map.setFilter('buildings', buildings)
          setTimeout(function() {
           _self.map.setPaintProperty('buildings', 'fill-extrusion-opacity', 0.6)
           $('.loader').fadeOut();
         }, 1000)

          var totals = {"type": "FeatureCollection", "features": [] }
          _.each(_self.groupedOrgs, function(group, index) {
              if (index === '') {
                _.each(group, function(org) {
                  totals.features.push({
                    type: "Feature",
                    "geometry": {
                      "coordinates": [
                        org.field_longitude,
                        org.field_latitude
                      ],
                      "type": "Point"
                    },
                    "properties": {
                      "count": 1,
                      "title": org.title,
                      "buildingId": "none",
                      "properties": org
                    }
                  })
                })
              } else {
              totals.features.push({
                type: "Feature",
                "geometry": {
                  "coordinates": [
                    group[0].field_longitude,
                    group[0].field_latitude
                  ],
                  "type": "Point"
                },
                "properties": {
                  "count": group.length,
                  "buildingId": group[0].field_building_id,
                  "category": group[0].field_category
                }
              })
            }
          });
          _self.map.addLayer({
            "id": "totals",
            "type": "circle",
            "source": {
              "type": "geojson",
              "data": totals,
             },
             "paint": {
               "circle-radius": {
                 "property": "count",
                 "type": "exponential",
                 "stops": [
                   [1, 6],
                   [2, 10],
                   [20, 30]
                 ]
               },
               "circle-stroke-color": "#fff",
               "circle-stroke-width": 2,
               "circle-color": '#44AFC5',
               "circle-opacity": 0.9
             }
          })
          _self.map.addLayer({
            "id": "totalLabels",
            "type": "symbol",
            "source": {
              "type": "geojson",
              "data": totals,
             },
             "layout": {
               "text-field": "{count}",
               "text-allow-overlap": true,
               "text-size": {
                 "property": "count",
                 "type": "exponential",
                 "stops": [
                   [1, 0],
                   [2, 10],
                   [20, 20]
                 ]
               },
               "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
             },
             "paint": {
                "text-color": '#fff'
             }
          })
       }
    });
  }

  _checkOrgs(response) {
    var _self = this;
    var filters = ["any"];
    _.each(response.features, function(feature) {
      var buildingId = feature.properties.buildingId;
      filters.push(["==", "id", buildingId])
    });
   _self.map.setFilter("buildings", filters)
  }

  _showOrganization(props) {
     var _self = this
     _self.organizationData = props
     _self.forceUpdate()
     $('#cast-popup').hide()
     // @todo: show organization panel based on state: this is a hack to stop them showing
     // each time the component updates
     _self.organizationData = null
  }


  closePopup(e) {
    e.preventDefault()
    $('#cast-popup').hide()
  }

  render() {
    return (
      <div>
        <div id="map" className="map"></div>
        <div id="cast-popup">
          <div className="cast-popup--title">
            Info
          </div>
          <a href="#close" className="close" onClick={ (e) => this.closePopup(e) }>x</a>
          <div className="cast-popup--content">
          </div>
        </div>
        {this.organizationData &&
          <Organization data={ this.organizationData } />
        }
        <div id="parcel-id"></div>
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js